// removed by extract-text-webpack-plugin
module.exports = {"binary_mention_filter_search":"_2b0qbyV11wFXoFNPrPzfS","binary_mention_search_overlay":"t7ltF8etbMS3grqPhWZpd","binary_search_input":"_8K-Wo9nCXFE2imTYvnh43"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/Search.scss
// module id = 2349
// module chunks = 0